export function unpack(axiosPromise) {
  return axiosPromise.then(
    response => response.data,
    error => { throw error.response.data }
  );
}
